import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'

import Header from '../Header'
import CompanyDetails from '../CompanyDetails'
import SkillsSection from '../SkillsSection'
import LifeAtCompanySection from '../LifeAtCompanySection'
import SimilarJobsSection from '../SimilarJobsSection'

import './index.css'

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  inProgress: 'IN_PROGRESS',
  failure: 'FAILURE',
}

class JobDetails extends Component {
  state = {
    jobDetails: {},
    lifeAtCompany: {},
    similarJobs: [],
    skills: [],
    apiStatus: apiStatusConstants.initial,
  }

  componentDidMount() {
    this.getJobDetails()
  }

  getJobDetails = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})

    const {match} = this.props
    const {params} = match
    const {id} = params
    const jwtToken = Cookies.get('jwt_token')
    const apiUrl = `https://apis.ccbp.in/jobs/${id}`
    console.log(apiUrl)
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(apiUrl, options)
    const data = await response.json()

    if (response.ok) {
      const updatedData = {
        jobDetails: {
          companyLogoUrl: data.job_details.company_logo_url,
          companyWebsiteUrl: data.job_details.company_website_url,
          employmentType: data.job_details.employment_type,
          id: data.job_details.id,
          jobDescription: data.job_details.job_description,
          location: data.job_details.location,
          packagePerAnnum: data.job_details.package_per_annum,
          rating: data.job_details.rating,
          title: data.job_details.title,
        },
        skills: data.job_details.skills.map(eachSkill => ({
          imageUrl: eachSkill.image_url,
          name: eachSkill.name,
        })),
        lifeAtCompany: {
          description: data.job_details.life_at_company.description,
          imageUrl: data.job_details.life_at_company.image_url,
        },
        similarJobs: data.similar_jobs.map(similarJob => ({
          companyLogoUrl: similarJob.company_logo_url,
          employmentType: similarJob.employment_type,
          id: similarJob.id,
          jobDescription: similarJob.job_description,
          location: similarJob.location,
          rating: similarJob.rating,
          title: similarJob.title,
        })),
      }

      this.setState({
        jobDetails: updatedData.jobDetails,
        lifeAtCompany: updatedData.lifeAtCompany,
        similarJobs: updatedData.similarJobs,
        skills: updatedData.skills,
        apiStatus: apiStatusConstants.success,
      })
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  renderJobDetailsView = () => {
    const {jobDetails, lifeAtCompany, similarJobs, skills} = this.state
    return (
      <div className="job-details-section">
        <div className="job-details-container">
          <CompanyDetails jobDetails={jobDetails} />
          <SkillsSection skills={skills} />
          <LifeAtCompanySection lifeAtCompany={lifeAtCompany} />
        </div>

        <h1 className="similar-jobs-heading">Similar Jobs</h1>
        <SimilarJobsSection similarJobs={similarJobs} />
      </div>
    )
  }

  renderLoadingView = () => (
    <div
      className="loader-container job-details-loader-and-failure"
      data-testid="loader"
    >
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  onClickRetryBtn = () => {
    this.getJobDetails()
  }

  renderFailureView = () => (
    <div className="failure-container loader-container job-details-loader-and-failure">
      <img
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        alt="failure view"
        className="job-details-failure-img"
      />
      <h1 className="failure-heading">Oops! Something Went Wrong</h1>
      <p className="failure-para">
        We cannot seem to find the page you are looking for.
      </p>
      <button
        type="button"
        className="retry-btn"
        onClick={this.onClickRetryBtn}
      >
        Retry
      </button>
    </div>
  )

  renderAccordingToApiStatus = () => {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderJobDetailsView()
      case apiStatusConstants.inProgress:
        return this.renderLoadingView()
      case apiStatusConstants.failure:
        return this.renderFailureView()
      default:
        return null
    }
  }

  render() {
    return (
      <div className="bg-container">
        <Header />
        {this.renderAccordingToApiStatus()}
      </div>
    )
  }
}

export default JobDetails
